"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    drawerSizes: ()=>drawerSizes,
    drawerSlots: ()=>drawerSlots,
    drawer: ()=>drawer,
    drawerVariants: ()=>drawerVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const drawer = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        overlaySlot: 'bg-neutral-13/50 fixed inset-0 z-[1100]',
        contentSlot: 'bg-neutral-1 outline-hidden shadow-overlay-lg fixed z-[1101] flex h-fit flex-col',
        headingTextSlot: 'text-neutral-13 font-semibold',
        closeButtonSlot: 'z-1',
        headingSlot: 'flex w-full flex-row items-center justify-between px-4',
        headingSlotLeft: 'flex flex-1 flex-row items-center',
        headingRightNodeSlot: 'mr-2',
        headingIconSlot: 'text-neutral-13 mr-2',
        bodySlot: 'py-4',
        footerSlot: '',
        popupScrollWrapperSlot: '',
        scrollAreaSlot: '',
        handlePositionSlot: 'absolute left-1/2 top-0 -translate-x-6',
        handleSlot: 'bg-primary-5 w-12! absolute left-0 top-3 -mb-3 h-1 cursor-grab rounded-full active:cursor-grabbing'
    },
    variants: {
        size: {
            sm: {
                contentSlot: 'w-full max-w-96'
            },
            md: {
                contentSlot: 'max-w-160 w-full'
            },
            lg: {
                contentSlot: 'max-w-240 w-full'
            },
            xl: {
                contentSlot: 'max-w-320 w-full'
            },
            full: {
                contentSlot: 'w-full'
            }
        },
        showDragHandle: {
            true: {
                contentSlot: 'pt-4',
                headingSlot: 'pt-0'
            },
            false: {
                headingSlot: 'pt-4'
            }
        },
        direction: {
            bottom: {
                contentSlot: 'bottom-0 left-1/2 -translate-x-1/2 rounded-t-2xl'
            },
            right: {
                contentSlot: 'right-0 -translate-x-4 rounded-2xl after:hidden'
            },
            left: {
                contentSlot: 'left-0 translate-x-4 rounded-2xl after:hidden'
            },
            top: {
                contentSlot: 'left-1/2 top-0 -translate-x-1/2 translate-y-4 rounded-2xl after:hidden'
            }
        },
        customFooter: {
            true: {
                contentSlot: 'pb-0'
            },
            false: {}
        },
        customBody: {
            true: {
                bodySlot: 'py-0'
            },
            false: {}
        },
        customHeader: {
            true: {
                contentSlot: 'pt-0',
                headingSlot: 'px-0',
                closeButtonSlot: 'absolute right-2 top-2'
            }
        },
        scroll: {
            none: {},
            body: {
                contentSlot: 'h-full max-h-[calc(100dvh-40px)]',
                scrollAreaSlot: 'h-[calc(100dvh-101px)]'
            }
        },
        stickyFooter: {
            true: {
                footerSlot: 'sticky bottom-0 left-0 right-0'
            }
        },
        showCloseButton: {
            true: {
                bodySlot: 'pt-2'
            }
        },
        useSnapping: {
            true: {}
        },
        hasHeadingText: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            showCloseButton: true,
            customBody: true,
            class: {
                bodySlot: 'pt-0'
            }
        },
        {
            useSnapping: true,
            direction: 'bottom',
            class: {
                contentSlot: 'mx-[-1px] h-full max-h-[97%]'
            }
        },
        {
            scroll: 'body',
            hasHeadingText: true,
            class: {
                headingSlot: 'border-b-1 border-neutral-6/50'
            }
        }
    ],
    defaultVariants: {
        direction: 'bottom',
        size: 'full',
        scroll: 'none',
        stickyFooter: false
    }
});
const drawerSlots = drawer.slots;
const drawerVariants = drawer;
const drawerSizes = Object.keys(drawerVariants.variants.size);
exports.drawer = __webpack_exports__.drawer;
exports.drawerSizes = __webpack_exports__.drawerSizes;
exports.drawerSlots = __webpack_exports__.drawerSlots;
exports.drawerVariants = __webpack_exports__.drawerVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "drawer",
    "drawerSizes",
    "drawerSlots",
    "drawerVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
